<template>
  <div ref="outerContainer" class="comp-org-persion-list">
    <div ref="listContainer" class="list" :style="listStyle">
      <jw-spin :loading="loading" class="spin">
        <template v-if="userList.length">
          <div v-for="(user, index) in userList" :key="user.id" @click.stop="handelClick(index)" class="list-item flex-s-c" :class="{ 'select-active': selectIndex === index }">
            <xl-avatar :avatar="{ name: user?.userName || '', url: user?.avatarOrigin, id: user?.id }" :hasName="false" :size="45" />
            <div class="list-item-container">
              <p>{{ user.userName }}</p>
              <p>{{ user.departmentName }}</p>
            </div>
          </div>
        </template>
        <jw-empty v-else />
      </jw-spin>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import { orgService } from '@/api/';
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
const loading = ref(false);

const emits = defineEmits(['close', 'change']);
const props = defineProps({
  keyWords: String,
  position: {
    type: Object,
    default: () => {
      return { left: 0, top: 0 };
    }
  }
});
const listContainer = ref(null);
// 动态计算列表弹出的位置（避免超出屏幕）
const listStyle = ref({
  width: '300px',
  left: 0,
  top: 0,
  visibility: 'hidden'
});

const updateListPosition = (newPosition = props.position) => {
  const list = listContainer.value;
  // 列表默认宽
  const listW = 300;
  const listH = list?.offsetHeight ? list?.offsetHeight : 153;
  // 默认偏移量
  const offset = 24;
  // 列表定位优先左上角
  const posData = {
    width: listW + 'px',
    left: 0,
    top: 0,
    visibility: 'visible'
  };
  const left = newPosition?.left;
  const top = newPosition?.top;

  const winWidth = window.innerWidth;
  const winHeight = window.innerHeight;
  if (winWidth - left > listW + offset) {
    posData.left = left + offset + 'px';
  } else {
    posData.left = left - listW - offset + 'px';
  }

  if (winHeight - top > listH + offset) {
    posData.top = top + offset + 'px';
  } else {
    const t = top - listH - offset;
    if (t < 0) {
      posData.top = 0;
    } else {
      posData.top = top - listH - offset + 'px';
    }
  }
  listStyle.value = posData;
  console.log('%c [ listStyle.value ]-67', 'font-size:13px; background:#b822b3; color:#fc66f7;', listStyle.value);
};

watch(
  () => props.position,
  (newVal) => {
    updateListPosition(newVal);
  },
  {
    immediate: true,
    deep: true
  }
);

// 监听鼠标点击空白区域 隐藏列表弹窗
const lintener = (event) => {
  event.stopPropagation();
  if (event.target.className === 'comp-org-persion-list') {
    emits('close');
  }
};

const selectIndex = ref(0);
// 监听键盘按下
const keydownListener = (event) => {
  if (event.keyCode === 13) {
    // 按下回车 弹窗出现时 阻止回车默认事件
    event.preventDefault();
    emits('change', {
      type: 'enter',
      userInfo: userList.value[selectIndex.value]
    });
  } else if ([38, 40].includes(event.keyCode)) {
    // 上下方向键阻止默认事件
    event.preventDefault();
    // 上下移动
    if (event.keyCode === 38) {
      selectIndex.value--;
      if (selectIndex.value < 0) selectIndex.value = 0;
    } else {
      // 判断索引是否等于当前列表最大长度，当等于最大值时保持不变
      if (selectIndex.value === userList.value.length - 1) {
        selectIndex.value = userList.value.length - 1;
      } else {
        selectIndex.value++;
      }
    }
    // 判断是否在可视区域内，不在可视区域需要调整滚动条位置
    nextTick(() => {
      // 避免loading过程中li元素获取不到导致js报错
      if (loading.value) return;
      checkInView();
    });
  }
};

// 点选
const handelClick = (index) => {
  emits('change', {
    type: 'click',
    userInfo: userList.value[index]
  });
};

// 检查所选列表项是否在可视区域内 如果不在则滚动到可视区域
const checkInView = () => {
  const list = listContainer.value;
  // 获取列表的滚动位置
  const scrollTop = list.scrollTop;
  // 获取列表的高度
  const listHeight = list.clientHeight;
  const li = list.querySelector('.select-active');
  // 获取<li>相对于列表的位置
  const liOffsetTop = li.offsetTop;
  // 获取<li>的高度
  const liHeight = li.clientHeight;
  // 判断<li>是否在可视区域内
  if (liOffsetTop + liHeight > scrollTop + listHeight || liOffsetTop < scrollTop) {
    // 如果不在可视区域内，调整滚动位置
    // 计算需要滚动到的位置
    const newScrollTop = liOffsetTop - listHeight / 2 + liHeight / 2;
    // 调整滚动位置
    list.scrollTop = newScrollTop;
  }
};

const userList = ref([]);
// 获取员工列表
const getUserList = () => {
  // setLoading(true)
  loading.value = true;
  const params = {
    all: true,
    conditions: [
      {
        field: '',
        isGroup: true,
        operation: 'and',
        value: '',
        children: [
          {
            field: 'userName',
            isGroup: false,
            operation: 'like',
            value: props.keyWords
          }
        ]
      }
    ],
    page: 1,
    pageSize: 10000
  };
  orgService
    .getUserList(params)
    .then((res) => {
      if (res.result) {
        userList.value = res.result?.records || [];
        selectIndex.value = 0;
        listContainer.value.scrollTop = 0;
        nextTick(() => {
          updateListPosition();
        });
      }
      loading.value = false;
    })
    .catch((error) => {
      console.log('%c [ error ]-167', 'font-size:13px; background:#03dd7e; color:#47ffc2;', error);
      loading.value = false;
    });
};

// 关键词更新
watch(
  () => props.keyWords,
  (newVal) => {
    console.log('%c [ newVal ]-52', 'font-size:13px; background:#fcc928; color:#ffff6c;', newVal);
    getUserList();
  }
);

const outerContainer = ref(null);
//监听事件
eventListener('keydown', keydownListener);
onMounted(() => {
  //页面卸载已移除监听 避免内存泄露
  outerContainer.value.addEventListener('click', lintener);
});
onBeforeUnmount(() => {
  outerContainer.value.removeEventListener('click', lintener);
});
</script>
<style scoped lang="less">
@import './org-persion-list.less';
</style>
